import template from './sectionHeader.html';
import './sectionHeader.scss';

export class SectionHeaderController {
  handleHeaderAction(action) {
    this.onHeaderActionClicked({ action });
  }
}

export default {
  controller: SectionHeaderController,
  template,
  bindings: {
    headerActions: '<',
    headerTitle: '<',
    headerSubtitle: '<?',
    onHeaderActionClicked: '&',
  },
  transclude: {
    components: '?sectionHeaderActionsComponents',
  },
};
